// import { Api } from '@/service';
import User from '@/views/Management/user/user.Detail.Summary.i18n'
import Partner from '@/views/Management/partner/partner.Detail.Summary.i18n'
import Admin from '@/views/Management/admin/admin.Detail.Summary.i18n'
// import VueJsonPretty from 'vue-json-pretty';
// import 'vue-json-pretty/lib/styles.css';
import JsonViewer from 'vue-json-viewer'

//restful api
import { actionLog as log } from '@/service/api/log'


export default {
  components: { JsonViewer, User, Partner, Admin },
  data : () => {
    return {
      model : { info : {} },
      tag : '',
      lock : true,
      is_modal : false
    }
  },
  methods: {
    list() { this.$router.push({ name: 'log_action'}); },
    async get( id = this.$route.params.id, tag = this.$route.params.tag) {
      console.log('log.action.detail.vue', 'load item', id, tag);
      this.tag = this.$route.params.tag.toUpperCase();
      try {
        // let rs = await Api.Manager_Call('log.action', `detail.${this.$route.params.tag}`, { id : Number(id.id) })

        console.log("tag :", this.$route.params.tag);

        if(this.$route.params.tag == 'user'){
          let rs = await log.detailUser({ id : Number(id.id) });

          if(rs.error) { return this.$toastr.e("get data tailed") }

          this.model = Object.assign({}, this.model, rs.body);

          try { this.model.info = JSON.parse(this.model.info) }
          catch(e) { console.log('info is not json') }
        }else if(this.$route.params.tag == 'partner'){
          let rs = await log.detailPartner({ id : Number(id.id) });

          if(rs.error) { return this.$toastr.e("get data tailed") }

          this.model = Object.assign({}, this.model, rs.body);

          try { this.model.info = JSON.parse(this.model.info) }
          catch(e) { console.log('info is not json') }
        }else{
          let rs = await log.detailAdmin({ id : Number(id.id) });

          if(rs.error) { return this.$toastr.e("get data tailed") }

          this.model = Object.assign({}, this.model, rs.body);

          try { this.model.info = JSON.parse(this.model.info) }
          catch(e) { console.log('info is not json') }
        }

      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created() { console.log('log.action.detail.vue', 'created'); },
  destroyed() { console.log('log.action.detail.vue', 'destroyed'); },
  mounted() {
    console.log('log.action.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}